<template>
  <div id="app">
    <router-view /> <!-- Este es el lugar donde se renderizará el componente de la ruta -->
    <FooterBrand />

 </div>
</template>

<script>
import FooterBrand from '@/components/FooterBrand.vue';

export default {
  name: 'App',
  components: {
    FooterBrand,
  }
};
</script>

<style>
/* Estilos para tu aplicación */
</style>
